module.exports = __webpack_public_path__ + "img/banner-talent-concept.0fc8954f.png";